import axiosFactory from "./axios.factory";

class PriceHistoryService {
  /** Preisverlauf einer SKU (Verkaufspreis brutto aus Afterbuy), neueste zuerst. */
  async getHistory(sku) {
    const result = await axiosFactory().get("/price-history", { params: { sku } });
    return result.data.data;
  }
}

export default new PriceHistoryService();
